module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./resources/scripts/data/default.json
// module id = 110
// module chunks = 0